import { render } from "./NewsView.vue?vue&type=template&id=28726c3d&scoped=true"
import script from "./NewsView.vue?vue&type=script&lang=js"
export * from "./NewsView.vue?vue&type=script&lang=js"

import "./NewsView.vue?vue&type=style&index=0&id=28726c3d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-28726c3d"

export default script